import { PriceType } from '@app/shared/types/common';
import { MediaData } from '@app/shared/types/player';

export interface Settlement {
  id: number;
  name: string;
  description: string;
  price: number;
  boostTonPrice: number;
  boostCookiePrice: number;
  imageUrl: string | null;
  noBgImageUrl: string | null;
  nodeLevel: number;
  isPurchased: boolean;
  isBoosted: boolean;
  boostProgress: number;
  pandas: number;
  tonIncome: number;
  availableAtLevel: number;
  purchasedCount: number;
  features: string[];
  // front
  hasDetails: boolean;
  isLocked: boolean;
}

export interface PurchaseSettlementPayload {
  settlementId: number;
}

export interface PurchaseSettlementResponse {
  ok: boolean;
  message: string;
}

export interface BoostSettlementPayload {
  settlementId: number;
  paymentType: PriceType;
}

export interface BoostSettlementResponse {
  ok: boolean;
  message: string;
}

export enum SettlementTagType {
  SETTLEMENTS = 'Settlements',
}

export interface SettlementDetailsData {
  bgImg: string;
  firstInteractiveImg: string;
  secondInteractiveImg: string;
  tracks: MediaData[];
  videos: MediaData[];
}
